import axios from 'axios';
export const API_URL = 'https://api.wocons.com:8443/api/';

const API = axios.create({
    baseURL:API_URL,
    headers:{
        'Content-Type':'application/json',
    },
});

API.interceptors.request.use(config=>{
    const token = localStorage.getItem('token');
    if(token) config.headers.Authorization=`Bearer ${token}`;

    return config;
});

export const createEnquiry = async (data:any) => {
    const response = await API.post("Enquiry/create", data);
    return response. data;
};
 


